import { TemplateProperty } from "src/lib/templates";

export const emailTemplate: TemplateProperty = {
  name: "email",
  type: { name: "string" },
  label: "Correo electrónico",
  validators: [{ name: "email", signature: [{ tlds: { allow: false } }] }],
};
